var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconHighlighter = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "var(--tool-color-dark)",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4628 14.0959C17.1876 13.0333 16.4563 11.4722 16.4563 9.81232V6.72827C16.4563 6.3399 16.1415 6.02515 15.7532 6.02515H8.22186C7.83368 6.02515 7.51874 6.3399 7.51874 6.72827V9.81232C7.51874 11.4722 6.7876 13.0335 5.51245 14.0959C4.07874 15.2906 3.19452 16.9891 3.02881 18.8282H20.9462C20.7807 16.9891 19.8965 15.2906 18.4628 14.0959Z",
    fill: "#var(--tool-color-dark)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9501 0.703135C14.9501 0.459421 14.8239 0.233103 14.6166 0.105112C14.4094 -0.0230616 14.1506 -0.0347803 13.9326 0.0741674L9.4137 2.33369C9.17548 2.45271 9.02515 2.69624 9.02515 2.96247V4.61884H14.9501V0.703135Z",
    fill: "#var(--tool-color-dark)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20.2344V23.2968C3 23.6852 3.31476 23.9999 3.70312 23.9999H20.272C20.6602 23.9999 20.9751 23.6852 20.9751 23.2968V20.2344H3Z",
    fill: "var(--tool-color)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHighlighter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-highlighter.2ed58757.svg";
export { ForwardRef as ReactComponent };